export enum Role {
  MS_ADMIN = 'MS_ADMIN',
  MS_PRACTICIAN = 'MS_PRACTICIAN',
  MS_SECRETARY = 'MS_SECRETARY',
  MS_USER_MANAGER = 'MS_USER_MANAGER',
  MS_PRESCRIPTOR = 'MS_PRESCRIPTOR',
  MS_STUDENT_PRACTICIAN = 'MS_STUDENT_PRACTICIAN',
  MS_COORDINATOR = 'MS_COORDINATOR',
}
